// src/components/CustomToolbar.js
import React from 'react';
import { Toolbar } from 'react-big-calendar';

const CustomToolbar = (toolbar) => {
  const goToBack = () => {
    toolbar.onNavigate('PREV');
  };

  const goToNext = () => {
    toolbar.onNavigate('NEXT');
  };

  const goToCurrent = () => {
    toolbar.onNavigate('TODAY');
  };

  const label = () => {
    const date = toolbar.date;
    const view = toolbar.view;
    const formattedDate = toolbar.localizer.format(date, 'MMMM YYYY');

    return <span className="toolbar-label">{formattedDate}</span>;
  };

  return (
    <div className="rbc-toolbar">
      <button type="button" onClick={goToBack}>
        Back
      </button>
      <button type="button" onClick={goToCurrent}>
        Today
      </button>
      <button type="button" onClick={goToNext}>
        Next
      </button>
      <div className="rbc-toolbar-label">{label()}</div>
    </div>
  );
};

export default CustomToolbar;
